<template>
  <div class="core">
    <div class="layui-fluid">
      <div class="layui-form layui-card-header layuiadmin-card-header-auto">
        <div class="layui-inline"><label class="layui-search-label">时间段:</label></div>
        <div class="layui-inline">
          <layui-daterange
            v-model="tableObj.queryObject.TIME_RANGE"
            @dateChange="handleDateChange($event)"
            ref="daterange"
          >
          </layui-daterange>
        </div>
        <button class="layui-btn layuiadmin-btn-list" title="查询" @click="search()">查 询</button>
        <div style="float: right;">
          <button class="layui-btn refresh" title="刷新列表" @click="reset()">
            <i class="layui-icon">&#xe669;</i>
            刷 新
          </button>
          <button class="layui-btn refresh" title="导出excel" @click="exportExcel()" style="margin-right:10px">
            <i class="layui-icon">&#xe67d;</i>
            导出
          </button>
          <layui-exportexcel
            ref="export"
            template-name="统计表.xlsx"
            table-name="YW_SERVICE_ORDER_V1,YW_SERVICE_ORDER_UNQUALIFIED_V2"
            :url="exportExcelUrl"
          >
          </layui-exportexcel>
        </div>
      </div>
      <div class="layui-tab layui-tab-brief">
        <ul class="layui-tab-title">
          <li :class="tab == 'tab1' ? 'layui-this' : ''" @click="handleChangeTab('tab1')">项目工单数据汇总</li>
          <li :class="tab == 'tab2' ? 'layui-this' : ''" @click="handleChangeTab('tab2')">工程师数据汇总</li>
          <li :class="tab == 'tab3' ? 'layui-this' : ''" @click="handleChangeTab('tab3')">服务门店数据汇总</li>
          <li :class="tab == 'tab4' ? 'layui-this' : ''" @click="handleChangeTab('tab4')">工单明细</li>
          <li :class="tab == 'tab5' ? 'layui-this' : ''" @click="handleChangeTab('tab5')">不合格工单明细</li>
          <!-- <li :class="tab == 'tab6' ? 'layui-this' : ''" @click="handleChangeTab('tab6')">异常工单明细</li> -->
        </ul>
        <div class="layui-tab-content">
          <div class="layui-tab-item" :class="tab == 'tab1' ? 'layui-show' : ''">
            <layui-table
              ref="table1"
              :lazy="true"
              table-name="YW_SUMMARY_CLIENT_V"
              :page-size="9999"
              :page-range="6"
              :page-options="[10, 20, 50, 100]"
              :show-page="false"
              :skin="'line'"
              :beforeRender="beforeRender1"
              :render-row="renderRow"
              :renderDone="renderDone('1')"
            >
              <div>
                <div title="序号" width="60" field="_NUMBER" align="center" fixed="left"></div>
                <layui-tableconfig :config="tableConfig1"></layui-tableconfig>
              </div>
            </layui-table>
          </div>
          <div class="layui-tab-item" :class="tab == 'tab2' ? 'layui-show' : ''">
            <layui-table
              ref="table2"
              :lazy="true"
              table-name="YW_SUMMARY_ENGINEER_V"
              :page-size="9999"
              :page-range="6"
              :page-options="[10, 20, 50, 100]"
              :show-page="false"
              :skin="'line'"
              :beforeRender="beforeRender2"
              :render-row="renderRow"
              :renderDone="renderDone('2')"
            >
              <div>
                <div title="序号" width="60" field="_NUMBER" align="center" fixed="left"></div>
                <layui-tableconfig :config="tableConfig2"></layui-tableconfig>
              </div>
            </layui-table>
          </div>
          <div class="layui-tab-item" :class="tab == 'tab3' ? 'layui-show' : ''">
            <layui-table
              ref="table3"
              :lazy="true"
              table-name="YW_SUMMARY_STORE_V"
              :page-size="9999"
              :page-range="6"
              :page-options="[10, 20, 50, 100]"
              :skin="'line'"
              :show-page="false"
              :beforeRender="beforeRender3"
              :render-row="renderRow"
              :renderDone="renderDone('3')"
            >
              <div>
                <div title="序号" width="60" field="_NUMBER" align="center" fixed="left"></div>
                <layui-tableconfig :config="tableConfig3"></layui-tableconfig>
              </div>
            </layui-table>
          </div>
          <div class="layui-tab-item" :class="tab == 'tab4' ? 'layui-show' : ''">
            <layui-table
              ref="table4"
              :lazy="true"
              table-name="YW_SERVICE_ORDER_V1"
              :page-size="20"
              :page-range="6"
              :page-options="[10, 20, 50, 100]"
              :skin="'line'"
              height="full-261"
            >
              <div>
                <div title="序号" width="60" field="_NUMBER" align="center" fixed="left"></div>
                <layui-tableconfig :config="tableConfig4"></layui-tableconfig>
              </div>
            </layui-table>
          </div>
          <div class="layui-tab-item" :class="tab == 'tab5' ? 'layui-show' : ''">
            <layui-table
              ref="table5"
              :lazy="true"
              table-name="YW_SERVICE_ORDER_UNQUALIFIED_V2"
              :page-size="20"
              :page-range="6"
              :page-options="[10, 20, 50, 100]"
              :skin="'line'"
              height="full-261"
            >
              <div>
                <div title="序号" width="60" field="_NUMBER" align="center" fixed="left"></div>
                <layui-tableconfig :config="tableConfig5"></layui-tableconfig>
              </div>
            </layui-table>
          </div>
          <div class="layui-tab-item" :class="tab == 'tab6' ? 'layui-show' : ''">
            <layui-table
              ref="table6"
              :lazy="true"
              table-name="YW_SERVICE_ORDER_YICHANG_V1"
              :page-size="20"
              :page-range="6"
              :page-options="[10, 20, 50, 100]"
              :skin="'line'"
              height="full-261"
            >
              <div>
                <div title="序号" width="60" field="_NUMBER" align="center" fixed="left"></div>
                <layui-tableconfig :config="tableConfig6"></layui-tableconfig>
              </div>
            </layui-table>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import request from '../../network/networkconfig'
import '../../utils/map/css/core.css'

export default {
  name: 'Statistics',
  data() {
    return {
      tab: 'tab1',
      tableConfig1: [
        { field: 'CLIENT_NAME', title: '客户名称', width: 300 },
        { field: 'YW_NUM', title: '运维' },
        { field: 'XJ_NUM', title: '巡检' },
        { field: 'AZ_NUM', title: '安装' },
        { field: 'KD_NUM', title: '开店' },
        { field: 'BD_NUM', title: '闭店' },
        { field: 'GZ_NUM', title: '改造' },
        { field: 'JC_NUM', title: '集成' },
        { field: 'QT_NUM', title: '其它' },
        { field: 'XJ', title: '小计' },
        { field: 'YC_NUM', title: '远程' },
        { field: 'ZYGCS_SM_NUM', title: '自有工程师上门', width: 150 },
        { field: 'FWS_SM_NUM', title: '服务商上门', width: 150 },
        { field: 'SMHJ_NUM', title: '上门合计', width: 150 },
        { field: 'FWS_SM_RATE', title: '服务商上门率', width: 150 }
      ],
      tableConfig2: [
        { field: 'ENG_PROVINCE_DESC', title: '省' },
        { field: 'ENG_CITY_DESC', title: '市' },
        { field: 'ENGINEER_NAME', title: '工程师', width: 130 },
        { field: 'YW_NUM', title: '运维' },
        { field: 'XJ_NUM', title: '巡检' },
        { field: 'AZ_NUM', title: '安装' },
        { field: 'KD_NUM', title: '开店' },
        { field: 'BD_NUM', title: '闭店' },
        { field: 'GZ_NUM', title: '改造' },
        { field: 'JC_NUM', title: '集成' },
        { field: 'QT_NUM', title: '其它' },
        { field: 'XJ', title: '小计' }
        // { field: 'FWS_SM_NUM', title: '服务商上门', width: 150},
        // { field: 'FWS_SM_RATE', title: '服务商上门率', width: 150},
        // { field: 'YC_RATE', title: '远程率', width: 150},
      ],
      tableConfig3: [
        { field: 'BRAND_NAME', title: '品牌名称', width: 300 },
        { field: 'ITJS_NUM', title: 'IT建设' },
        { field: 'YW_NUM', title: '运维/其他' },
        { field: 'ITJS_NUM_BY', title: '本月增加IT建设' },
        { field: 'YW_NUM_BY', title: '本月增加运维/其他' },
        { field: 'KD_NUM', title: '新增门店数量' },
        { field: 'HJ_NUM', title: '合计' }
      ],
      tableConfig4: [
        { field: 'SERVICE_ORDER_NUM', title: '现场服务单编号', width: 160 },
        { field: 'YW_WORK_ORDER_CREATE_TIME', title: '创建时间（秒）', width: 160 },
        { field: 'BRAND_NAME', title: '品牌', width: 160 },
        { field: 'STORE_NAME', title: '门店名称', width: 160 },
        { field: 'STORE_MANAGER_PHONE', title: '联系方式', width: 160 },
        { field: 'WORK_ORDER_TYPE_DESC', title: '工单类型', width: 160 },
        { field: 'DESCRIPTION', title: '描述', width: 160 },
        { field: 'WRONG_TYPE_DESC', title: '故障类型', width: 160 },
        { field: 'SLA_LEVEL', title: 'SLA等级', width: 160 },
        { field: 'WORK_ORDER_METHOD_DESC', title: '服务方式', width: 160 },
        { field: 'YW_SERVICE_ORDER_CREATE_USERID_DESC', title: '客服工程师', width: 160 },
        { field: '', title: '远程解决结果', width: 160 },
        { field: 'ORDER_STATE_DESC', title: '工单状态', width: 160 },
        { field: 'WORK_ORDER_NUM', title: '服务请求单编号', width: 160 },
        { field: 'SERVICE_NAME', title: '服务商', width: 160 },
        { field: 'ENGINEER_NAME', title: '现场工程师', width: 160 },
        { field: 'YW_SERVICE_ORDER_CREATE_TIME', title: '分配时间（秒）', width: 160 },
        { field: 'ORDER_TAKING_TIME', title: '接单时间（秒）', width: 160 },
        { field: 'APPOINT_TIME', title: '预约时间（秒）', width: 160 },
        { field: 'SIGNIN_TIME', title: '到达时间（秒）', width: 160 },
        { field: 'CHECK_TIME', title: '解决时间（秒）', width: 160 },
        { field: 'CHECK_DESC', title: '处理过程', width: 160 },
        { field: 'CHECK_RESULT', title: '处理结果', width: 160 },
        { field: '', title: '订单金额', width: 160 },
        { field: '', title: '工单金额', width: 160 },
        { field: 'SERVICE_DESCRIPTION', title: '补充描述', width: 160 },
        { field: 'STANDARD_PROCESSING_TIME', title: '标准处理时间', width: 160 },
        { field: 'PROCESSING_TIME', title: '处理时长', width: 160 },
        { field: 'ALLOWANCE_TIME', title: '补贴时长', width: 160 },
        { field: 'STORE_DICT_AREA', title: '大区', width: 160 },
        { field: 'STORE_P_DESC', title: '省', width: 160 },
        { field: 'STORE_C_DESC', title: '市', width: 160 }
      ],
      tableConfig5: [
        { field: 'SERVICE_ORDER_NUM', title: '现场服务单编号', width: 160 },
        { field: 'UNQUALIFIED_REASON', title: '不合格原因', width: 300 },
        { field: 'YW_WORK_ORDER_CREATE_TIME', title: '创建时间（秒）', width: 160 },
        { field: 'BRAND_NAME', title: '品牌', width: 160 },
        { field: 'STORE_NAME', title: '门店名称', width: 160 },
        { field: 'STORE_MANAGER_PHONE', title: '联系方式', width: 160 },
        { field: 'WORK_ORDER_TYPE_DESC', title: '工单类型', width: 160 },
        { field: 'DESCRIPTION', title: '描述', width: 160 },
        { field: 'WRONG_TYPE_DESC', title: '故障类型', width: 160 },
        { field: 'SLA_LEVEL', title: 'SLA等级', width: 160 },
        { field: 'WORK_ORDER_METHOD_DESC', title: '服务方式', width: 160 },
        { field: 'YW_SERVICE_ORDER_CREATE_USERID_DESC', title: '客服工程师', width: 160 },
        { field: '', title: '远程解决结果', width: 160 },
        { field: 'ORDER_STATE_DESC', title: '工单状态', width: 160 },
        { field: 'WORK_ORDER_NUM', title: '服务请求单编号', width: 160 },
        { field: 'SERVICE_NAME', title: '服务商', width: 160 },
        { field: 'ENGINEER_NAME', title: '现场工程师', width: 160 },
        { field: 'YW_SERVICE_ORDER_CREATE_TIME', title: '分配时间（秒）', width: 160 },
        { field: 'ORDER_TAKING_TIME', title: '接单时间（秒）', width: 160 },
        { field: 'APPOINT_TIME', title: '预约时间（秒）', width: 160 },
        { field: 'SIGNIN_TIME', title: '到达时间（秒）', width: 160 },
        { field: 'CHECK_TIME', title: '解决时间（秒）', width: 160 },
        { field: 'CHECK_DESC', title: '处理过程', width: 160 },
        { field: 'CHECK_RESULT', title: '处理结果', width: 160 },
        { field: '', title: '订单金额', width: 160 },
        { field: '', title: '工单金额', width: 160 },
        { field: 'SERVICE_DESCRIPTION', title: '补充描述', width: 160 },
        { field: 'STANDARD_PROCESSING_TIME', title: '标准处理时间', width: 160 },
        { field: 'PROCESSING_TIME', title: '处理时长', width: 160 },
        { field: 'ALLOWANCE_TIME', title: '补贴时长', width: 160 },
        { field: 'STORE_DICT_AREA', title: '大区', width: 160 },
        { field: 'STORE_P_DESC', title: '省', width: 160 },
        { field: 'STORE_C_DESC', title: '市', width: 160 }
      ],
      tableConfig6: [
        { field: 'E_TYPE', title: '异常类型', width: 260 },
        { field: 'SERVICE_STATE_DESC', title: '现场服务单状态', width: 150, sort: true },
        { field: 'WORK_ORDER_TYPE_DESC', title: '现场服务单类型', width: 130 },
        { field: 'WORK_ORDER_NUM', title: '服务请求单编号', width: 130 },
        { field: 'SERVICE_ORDER_NUM', title: '现场服务单编号', width: 150 },
        { field: 'CLIENT_NAME', title: '客户', width: 260 },
        { field: 'BRAND_NAME', title: '品牌', width: 130 },
        { field: 'STORE_NAME', title: '门店', width: 230 },
        { field: 'ENGINEER_NAME', title: '工程师', width: 100 },
        { field: 'SERVICE_NAME', title: '服务商', width: 200 },
        { field: 'YW_SERVICE_ORDER_CREATE_TIME', title: '创建时间', width: 160 }
      ],
      tableObj: {
        checkedRows: 0,
        queryObject: {}
      },
      searchConfig: {
        basic: [
          {
            TYPE: 'input',
            WIDTH: 260,
            FIELD:
              'WORK_ORDER_NUM:2,CLIENT_NAME:2,BRAND_NAME:2,STORE_NAME:2,MANAGER_NAME:2,SERVICE_NAME:2,SERVICE_ORDER_NUM:2,ENGINEER_NAME:2',
            PLACEHOLDER: '请输入查询条件'
          }
        ]
      },
      exportExcelUrl: '',
      exportTemplate: '统计表.xlsx'
    }
  },
  mounted() {
    this.exportExcelUrl = process.env.API_HOST + '/yw/export/excel/statistics' //导出请求url
    for (var i = 1; i < 7; i++) {
      this['table' + i] = this.$refs['table' + i]
      this['table' + i].newResult = null
    }
    this.table1.load()
  },
  methods: {
    /**
     * tabs改变事件
     */
    handleChangeTab(type) {
      var num = type.substring(type.length - 1, type.length)
      this['table' + num].queryObject = this.tableObj.queryObject
      if (type != 'tab1' && type != 'tab2') {
        this['table' + num].load()
      }
      this.tab = type
      this.queryTab1OrTab2()
    },
    search() {
      for (var i = 1; i < 7; i++) {
        this['table' + i].queryObject = this.tableObj.queryObject
        if (i != 1 && i != 2) {
          this['table' + i].load()
        }
      }
      this.queryTab1OrTab2()
    },
    //设置 tab1/tab2 的查询条件
    queryTab1OrTab2() {
      if (this.tab == 'tab1' || this.tab == 'tab2') {
        var load_num = this.tab.substring(this.tab.length - 1, this.tab.length)
        this['table' + load_num].newResult = null
        var tableName = this.tab == 'tab1' ? 'YW_SUMMARY_CLIENT_V' : 'YW_SUMMARY_ENGINEER_V'
        var startTime = this.tableObj.queryObject['YW_WORK_ORDER_CREATE_TIME:5']
          ? this.tableObj.queryObject['YW_WORK_ORDER_CREATE_TIME:5']
          : ''
        var endTime = this.tableObj.queryObject['YW_WORK_ORDER_CREATE_TIME:6']
          ? this.tableObj.queryObject['YW_WORK_ORDER_CREATE_TIME:6']
          : ''
        request({
          url: process.env.API_HOST + '/yw/pageQuery/statisticsQuery',
          method: 'post',
          params: { tableName: tableName, startTime: startTime, endTime: endTime }
        }).then(result => {
          var point = 1
          result.result.forEach(e => {
            e._NUMBER = point++
          })
          this['table' + load_num].newResult = result.result
          this['table' + load_num].load()
        })
      }
    },
    reset() {
      this.tableObj.queryObject = {}
      for (var i = 1; i < 7; i++) {
        this['table' + i].queryObject = {}
        this['table' + i].newResult = null
      }
      var load_num = this.tab.substring(this.tab.length - 1, this.tab.length)
      this['table' + load_num].load()
    },
    //导出
    exportExcel() {
      let obj = Object.assign({}, this.table1)
      obj.defaultCondition = ''
      obj.queryObject = this.tableObj.queryObject
      var exportObj = this.$refs.export
      exportObj.export(obj)
    },
    //时间段
    handleDateChange(daterange) {
      this.tableObj.queryObject.TIME_RANGE = daterange
      var range = daterange.split(' - ')
      var startTime = range[0]
      var endTime = range[1]
      this.tableObj.queryObject['YW_WORK_ORDER_CREATE_TIME:5'] = startTime
      this.tableObj.queryObject['YW_WORK_ORDER_CREATE_TIME:6'] = endTime + ' 24:00:00'
    },
    beforeRender1(data) {
      data = this.table1.newResult ? this.table1.newResult : this.table1.data
      if (data && data.length > 1) {
        var totalRow = { totalRow: true }
        data.unshift(totalRow)
      }
      this.table1.data = data
    },
    beforeRender2(data) {
      data = this.table2.newResult ? this.table2.newResult : this.table2.data
      if (data && data.length > 1) {
        var totalRow = { totalRow: true }
        data.unshift(totalRow)
      }
      this.table2.data = data
    },
    beforeRender3(data) {
      if (data && data.length > 1) {
        var totalRow = { totalRow: true }
        data.unshift(totalRow)
      }
      this.table3.data = data
    },
    renderRow(row) {
      var load_num = this.tab.substring(this.tab.length - 1, this.tab.length)
      if (this.tab == 'tab' + load_num) {
        var data = this['table' + load_num].data
        if (row.totalRow) {
          //要从1开始，第0个是合计
          for (var i = 1; i < data.length; i++) {
            var item = data[i]
            for (var key in item) {
              if ('CLIENT_ID_,CLIENT_NAME,FWS_SM_RATE,FWS_SM_RATE_NUM,IS_NEW,_SLAVE'.indexOf(key) > -1) {
                continue
              }
              row[key] = (row[key] ? Math.round(row[key] * 100) / 100 : 0) + this.getNumber(item[key])
            }
          }
          row.FWS_SM_RATE = row.SMHJ_NUM != 0 ? ((row.FWS_SM_NUM / row.SMHJ_NUM) * 100).toFixed(2) + '%' : 0
          row.YC_RATE = row.XJ != 0 ? ((row.YC_NUM / row.XJ) * 100).toFixed(2) + '%' : 0
          row._NUMBER = 1
          return
        }
      }
    },
    renderDone(num) {
      if (this.tab == 'tab' + num) {
        if (this['table' + num] && this['table' + num].data && this['table' + num].data.length > 0) {
          var data = this['table' + num].data
          var trs = $('.layui-tab-item.layui-show .layui-table-body>.layui-table').find('tr')
          if (data.length == 1) {
            //如果只有一条记录
            //trs.hide();
            return
          }
          var firstTr = $(trs[0])
          var firstTd = firstTr[0].children[1]
          if (num == '2') {
            firstTr.find('[data-field=ENG_CITY_DESC]').hide()
            firstTr.find('[data-field=ENGINEER_NAME]').hide()
            $(firstTd)
              .attr('colspan', 3)
              .find('.layui-table-cell')
              .text('合计')
          } else {
            $(firstTd)
              .attr('colspan', 1)
              .find('.layui-table-cell')
              .text('合计')
          }
        }
      }
    },
    getNumber(item) {
      return item ? Math.round(item * 100) / 100 : 0
    }
  }
}
</script>
<style scoped>
.layui-card-header .layui-inline >>> .layui-icon-date {
  top: -4px !important;
}
.layui-tab-content {
  padding: 0 2px;
}
</style>



// WEBPACK FOOTER //
// src/components/statistics/index.vue